import React, { Component } from "react";

import Winners from "./Winners";

import Logo from "../Components/Logo";

import { Parallax } from "react-parallax";
import ModelSpecs from "./ModelSpecs";
import Video from "./Video";

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.winCar = React.createRef();

    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  componentDidMount() {
    //console.log(this.winCar.current.offsetTop)
  }

  handleToggleClick(e) {
    const currentButton = "content-" + e.target.dataset.contentid;
    this.setState((prevState) => ({
      [currentButton]: !prevState[currentButton],
    }));
  }

  triggerModal(type = "rules") {
    this.props.modal(type);
  }

  render() {
    const { language, winners } = this.props;
    return (
      <div className="content--wrapper" ref={this.winCar}>
        <div className="content--inside" id="campaign">
          <div className="content--full content--header">
            {language === "et" ? (
              <p className="slogan text--align__center goldenText"></p>
            ) : (
              <>
                <p className="slogan text--align__center goldenText">
                
                </p>
              </>
            )}
          </div>

          <div className="content--full">
            {language === "et" ? (
              <>
                <p>
                  Mängides nüüd KENO lotot{" "}
                  <strong>vähemalt 2 € panusega</strong>, osaled{" "}
                  KENO lisaloosis, kus iga nädal võidab üks
                  mängija 800 eurot kuus terveks aastaks.
                </p>

                <p>
                Lisaloosis osalevad
                02.09 – 27.10 toimuvatele loosimistele ostetud piletid.
                Võitjad selguvad esmaspäeviti alates 09.09.
                </p>
              </>
            ) : (
              <>
                <p>
                  Играя в лотерею KENO <strong>с минимальной ставкой в{" "}
                  2 евро</strong>, участвуете в дополнительном розыгрыше
                  KENO, в котором каждую неделю один игрок выигрывает 800 евро в
                  месяц на протяжении всего года!
                </p>

                <p>
                В дополнительном розыгрыше участвуют билеты, купленные к розыгрышам, проводимым 02.09–27.10.
                </p>
              </>
            )}

            {
              //                Loosimised toimuvad 07. mail, 14. mail, 21. mail ja 28. mail 2023.{" "}
              /*this.state["content-1"] ? (
              <p>
                {language === "et" ? (
                  <>
                    Igal teisipäeval ja reedel loositakse välja kaks (2)
                    piletit, 
                  </>
                ) : (
                  <>
                    Каждые вторник и пятницу разыгрываются два (2) билета,
                  
                  </>
                )}
              </p>
            ) : (
              ""
            )}

            <button
              data-contentid="1"
              onClick={this.handleToggleClick}
              className="button button--white"
            >
              {!this.state["content-1"]
                ? language === "et"
                  ? "Loe lisaks"
                  : "Дополнительная информация"
                : language === "et"
                ? "Sulge"
                : "Закрыть"}
            </button>
            */
            }
          </div>

          <Winners language={language} winners={winners} />

          <Logo src="assets/images/EL_blue.svg" alt="Eesti Loto" />

          <p className="disclaimer">
            {language === "et"
              ? `Tähelepanu! Tegemist on hasartmängu reklaamiga. Hasartmäng pole
            sobiv viis rahaliste probleemide lahendamiseks. Tutvuge reeglitega
            ja käituge vastutustundlikult!`
              : `Внимание! Вы имеете дело с рекламой азартной игры. Азартные игры не являются средством решения материальных проблем. Ознакомьтесь с правилами и поступайте ответственно!`}
          </p>
        </div>
      </div>
    );
  }
}
